<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <alertsp :alertdata="alertdata"></alertsp>
        <v-form
          @submit.prevent="submitLogin"
          ref="formlogin"
          v-model="formin.valid"
          lazy-validation>
          <v-text-field
            v-model="login.nik"
            :counter="16"
            :rules="[rules.required]"
            label="NIK / Username"
            name="nik"
            required>
          </v-text-field>
          <v-text-field
            v-model="login.password"
            :append-icon="formin.password ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.minpass]"
            :type="formin.password ? 'text' : 'password'"
            name="password"
            label="Password"
            hint="At least 6 characters"
            counter
            @click:append="formin.password = !formin.password">
          </v-text-field>
          <v-checkbox
            v-model="login.remember"
            label="Remember me?">
          </v-checkbox>
          <div class="text-center" v-if="loading.login">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </div>
          <v-btn
            v-if="!loading.login"
            type="submit"
            large
            block
            :disabled="!formin.valid"
            color="success"
            class="mr-4">
            Login
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Login',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      login: false,
    },
    api: process.env.VUE_APP_API,
    publickey: '123',
    login: {
      nik: '',
      password: '',
      remember: true,
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
    },
    word: 'Vue',
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitLogin() {
      this.alertdata.show = false;
      if (this.$refs.formlogin.validate()) {
        this.loading.login = true;
        this.axios
          .post(
            this.api + '/api/auth/login',
            qs.stringify(
              this.login,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.$store.commit('AUTH_SUCCESS', resdata.data);
                this.$router.push({ name: 'Home' });
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.login = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.login = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
